import { render, staticRenderFns } from "./TermlyModal.vue?vue&type=template&id=046a83b0"
import script from "./TermlyModal.vue?vue&type=script&lang=js"
export * from "./TermlyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports